import React, { useEffect, useState } from "react";

import { ModifierSetDto } from "services/modifierSets/restModels";
import { Button, EmptyState, LabeledField, Modal, Stack, TextInput } from "shared/ui";
import { localizedText } from "shared/lib/localizedMap";

import { modifierSetSummary } from "features/ModifierSets/lib/modifierSetSummary";

import { ResultMeta, ResultName, ResultRow, Results } from "./styles";

interface AddModifierSetDialogProps {
    open: boolean;
    // Наборы заведения, ещё не подключённые к позиции.
    availableModifierSets: ModifierSetDto[];
    locale: string;
    onClose: () => void;
    onAdd: (modifierSetId: number) => void;
    onCreateNew: () => void;
}

// Поиск идёт по уже загруженному каталогу: он приезжает одним запросом и лежит в кеше хука,
// поэтому ходить на бэк на каждое нажатие клавиши незачем.
const matches = (modifierSet: ModifierSetDto, query: string, locale: string) => {
    if (!query) return true;

    const haystack = [localizedText(modifierSet.name, locale), ...Object.values(modifierSet.name)]
        .join(" ")
        .toLowerCase();

    return haystack.indexOf(query.trim().toLowerCase()) !== -1;
};

export const AddModifierSetDialog = ({
    open,
    availableModifierSets,
    locale,
    onClose,
    onAdd,
    onCreateNew,
}: AddModifierSetDialogProps) => {
    const [search, setSearch] = useState<string>("");

    useEffect(() => {
        if (open) setSearch("");
    }, [open]);

    const found = availableModifierSets.filter((modifierSet) =>
        matches(modifierSet, search, locale)
    );

    const renderResults = () => {
        if (availableModifierSets.length === 0) {
            return <EmptyState description="Все наборы заведения уже подключены к этой позиции" />;
        }

        if (found.length === 0) {
            return <EmptyState description={`По запросу «${search}» ничего не нашлось`} />;
        }

        return (
            <Results>
                {found.map((modifierSet) => (
                    <ResultRow
                        key={modifierSet.id}
                        type="button"
                        onClick={() => onAdd(modifierSet.id)}
                    >
                        <ResultName>{localizedText(modifierSet.name, locale)}</ResultName>
                        <ResultMeta>{modifierSetSummary(modifierSet)}</ResultMeta>
                    </ResultRow>
                ))}
            </Results>
        );
    };

    return (
        <Modal
            open={open}
            onClose={onClose}
            title="Добавить набор"
            actions={
                <>
                    <Button variant="outlined" color="neutral" onClick={onClose}>
                        Отмена
                    </Button>
                    <Button variant="contained" onClick={onCreateNew}>
                        Создать новый набор
                    </Button>
                </>
            }
        >
            <Stack>
                {availableModifierSets.length > 0 && (
                    <LabeledField label="Набор заведения">
                        <TextInput
                            value={search}
                            onChange={setSearch}
                            placeholder="Поиск по названию"
                        />
                    </LabeledField>
                )}

                {renderResults()}
            </Stack>
        </Modal>
    );
};
